import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Button from "@material-ui/core/Button";
import withCustomStyles from "./GButton.style";

const MUI_VARIANT = {
  primary: "contained",
  secondary: "contained",
  outline: "outlined",
  ghost: "text",
  destructive: "contained"
};

const MUI_SIZE = { lg: "large", md: "medium", sm: "small" };

// Pill button. One primary per view; pair it with secondary / ghost.
// `price` puts an amount at the right in 800 weight ("Place order  Rs 3,997").
const GButton = React.forwardRef(function GButton(
  {
    classes,
    className,
    variant,
    size,
    price,
    icon,
    iconOnly,
    children,
    ...rest
  },
  ref
) {
  return (
    <Button
      ref={ref}
      variant={MUI_VARIANT[variant]}
      color={variant === "primary" ? "primary" : "default"}
      size={MUI_SIZE[size]}
      className={classnames(
        classes.root,
        classes[variant],
        classes[size],
        {
          [classes.iconOnly]: iconOnly,
          [classes.withPrice]: Boolean(price)
        },
        className
      )}
      {...rest}
    >
      {icon && (
        <span className={classes.icon} aria-hidden="true">
          {icon}
        </span>
      )}
      {children}
      {price && <span className={classes.price}>{price}</span>}
    </Button>
  );
});

GButton.propTypes = {
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "outline",
    "ghost",
    "destructive"
  ]),
  size: PropTypes.oneOf(["lg", "md", "sm"]),
  price: PropTypes.node,
  icon: PropTypes.node,
  iconOnly: PropTypes.bool
};

GButton.defaultProps = {
  variant: "primary",
  size: "md",
  iconOnly: false
};

export default withCustomStyles(GButton);
